import { IWorkspace } from "../../common/interfaces";

import { getCallable } from "../_sdk/client";
import { GetWorkspaceRequest, GetWorkspaceForRequest, UpdateWorkspaceRequest } from "./types";
import { endpoints, apiName } from "./endpoints";

export { apiName };

const getWorkspace = getCallable<GetWorkspaceRequest, IWorkspace>(apiName, "getWorkspace", {
    ...endpoints.getWorkspace,
    composer: request => {
        return {
            url: `/workspaces/${encodeURIComponent(request.id)}`,
            options: {
                method: "GET"
            }
        };
    }
});

const getWorkspaceFor = getCallable<GetWorkspaceForRequest, IWorkspace>(apiName, "getWorkspaceFor", {
    ...endpoints.getWorkspaceFor,
    composer: request => {
        return {
            url: `/workspaces/${encodeURIComponent(request.originalEntityType)}/${encodeURIComponent(request.originalEntityId)}`,
            options: {
                method: "GET"
            }
        };
    }
});

const updateWorkspace = getCallable<UpdateWorkspaceRequest, IWorkspace>(apiName, "updateWorkspace", {
    ...endpoints.updateWorkspace,
    composer: request => {
        return {
            url: `/workspaces/${encodeURIComponent(request.id)}`,
            options: {
                method: "PUT",
                body: JSON.stringify(request)
            }
        };
    }
});

export const callables = {
    getWorkspace,
    getWorkspaceFor,
    updateWorkspace
};
